import { InjectionToken } from '@angular/core';

export const SHOW_ETHNIKI_LOGO = new InjectionToken<boolean>('SHOW_ETHNIKI_LOGO', {
  providedIn: 'root',
  factory: () => false // Default to false
});
